import { useQuery } from '@tanstack/react-query';

import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';
import { CompanionRuleExecutionsResponse } from '@frontend/types';

export function useAppCompanionRuleExecutions(
  agentId: string,
  ruleId: string | undefined,
  page: number = 1,
  limit: number = 20
) {
  return useQuery({
    queryKey: ['opal:app-companion', 'rules', agentId, ruleId, 'executions', page, limit],
    queryFn: async () => {
      const res = await http.get<CompanionRuleExecutionsResponse>(
        `${OPAL_URL}/app-companion/agents/${agentId}/rules/${ruleId}/executions`,
        {
          params: {
            page,
            limit,
          },
        }
      );
      return res.data;
    },
    enabled: !!agentId && !!ruleId,
    staleTime: 30000,
    refetchInterval: 5000,
  });
}
